<template>
    <v-stepper-step
        class="habiteo-body-2 export-step pb-8"
        :complete="currentStep > stepId"
        :edit-icon="'$complete'"
        :key="`step-${stepId}`"
        :step="stepId"
    >
        {{ step.title }}
    </v-stepper-step>
</template>

<script>
    export default {
        name: 'StepSummaryItem',
        props: {
            currentStep: {
                type: Number,
                required: true
            },
            stepId: {
                type: Number,
                required: true
            },
            step: {
                type: Object,
                required: true
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/components/StepSummaryItem.vue